export default __webpack_public_path__ + "d873883a040bee3f0257dabd79d9de96.svg";